import React from "react";
import AddEntityPopup from "components/Records/NewRecordPages/AddEntityPopup";
import { textMessageAPI } from "api/Interactions/TextMessagesAPI";

interface AddTextMessagePopupProps {
  open: boolean;
  onClose: () => void;
  onSaved?: (newTextMessage: any) => void;
}

const AddTextMessagePopup: React.FC<AddTextMessagePopupProps> = ({ open, onClose, onSaved }) => {
  return (
    <AddEntityPopup
      open={open}
      onClose={onClose}
      title="Add New Text Message"
      createFunction={textMessageAPI.create as (data: Record<string, any>) => Promise<any>}
      fields={[
        { name: "name", label: "Title", required: true },
        { name: "description", label: "Description"},
        { name: "linked_campaign", label: "Campaign", required: true },
      ]}
      onSaved={onSaved}
    />
  );
};

export default AddTextMessagePopup;
